import { render, staticRenderFns } from "./admin-update.vue?vue&type=template&id=7b49a250&"
import script from "./admin-update.vue?vue&type=script&lang=js&"
export * from "./admin-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports